'use client';

export interface GeolocationCallbacks {
  /** called when geolocation is unavailable  */
  onGeoLocationUnavailable?: () => void;
  /** called when geolocation is available and returns GeolocationCoordinates */
  onGetGeoCoordinates?: (cords: GeolocationCoordinates) => void;
  /** called when geolocation is available and returns GeolocationPositionError */
  onGetGeoCoordinatesError?: (error: GeolocationPositionError) => void;
  /** called when loading state changes */
  onGetGeoCoordinatesLoadingStateChange?: (state: boolean) => void;
}

export const getDevicePosition = ({
  onGeoLocationUnavailable,
  onGetGeoCoordinates,
  onGetGeoCoordinatesError,
  onGetGeoCoordinatesLoadingStateChange
}: GeolocationCallbacks) => {
  if (!navigator.geolocation) {
    !!onGeoLocationUnavailable && onGeoLocationUnavailable();
    return;
  }

  !!onGetGeoCoordinatesLoadingStateChange && onGetGeoCoordinatesLoadingStateChange(true);

  navigator.geolocation.getCurrentPosition(
    (position) => {
      !!onGetGeoCoordinates && onGetGeoCoordinates(position.coords);
      !!onGetGeoCoordinatesLoadingStateChange && onGetGeoCoordinatesLoadingStateChange(false);
    },
    (error) => {
      !!onGetGeoCoordinatesError && onGetGeoCoordinatesError(error);
      !!onGetGeoCoordinatesLoadingStateChange && onGetGeoCoordinatesLoadingStateChange(false);
    },
    {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 20 * 60 * 1000 // 1200000 ms
    }
  );
};
